<template>
  <v-card outlined class="d-flex flex-column" height="84vh">
    <v-card-text style="flex: 0 0 auto">
      <note-details></note-details>
    </v-card-text>
    <v-divider class="mx-4"></v-divider>
    <span class="subtitle-1 ma-3">Table of Contents</span>
    <v-card-text style="overflow-y: auto; flex: 1 1 auto" id="toc">
      <note-toc></note-toc>
    </v-card-text>
  </v-card>
</template>
<script>
import NoteDetails from "./note-details.vue";
import NoteToc from "./note-toc.vue";
export default {
  components: {
    NoteDetails,
    NoteToc,
  },
};
</script>
